module.exports = __webpack_public_path__ + "static/media/(H)-Prata-09.25a0ec9d.jpg";